module.exports = __webpack_public_path__ + "static/media/betamax.595719c4.svg";